module.exports = function(app) {
    app.factory('spaUtil', ['$q', 'services','sessionData','dataManager','userUtil',"invisibleForm","$cookies","coremetrics",
        function($q, services,sessionData,dataManager,userUtil,invisibleForm,$cookies,coremetrics) {
            var memberData = sessionData.memberInfo;
            var
                getHmAccountDisplaySeq,
                getClientName,
                getHmAccountTypes,
                getFinalHmAccountDisplaySeq,
                acclarisSSO,
                newAcclaris,isCSR,isFutureAccount,isCancelledAccount,jsonScrubber,getHmAccountTypesNoNull,
                sortReceiptsByServiceDateAscending,sortReceiptsByServiceDateDescending;

            getHmAccountDisplaySeq = function(accountType,accountTypes) {
                var accountTypesObj =accountTypes;
                for(var accountTypesCounter = 0; accountTypesCounter < accountTypesObj.length; accountTypesCounter++) {
                    if(accountTypesObj[accountTypesCounter].acclarisCode == accountType) {
                        var sequence = accountTypesObj[accountTypesCounter].sequenceNo;
                        // Add ".1" to these accounts so they show up after related account ("HRA", "RPR1" in list.
                        // For example since "HRA" and "HRAW" are both sequence 1, they could show up in either the
                        // first or second position in the list. "HRAW" is suppose to be second so this will allow for that.
                        if (accountType == "HRAW" || accountType == "RPR2") {
                            sequence = sequence + ".1";
                        }
                        return sequence;
                    }
                };
            };

            getClientName=function(groupCode) {
                var clientList = memberData.clientList;
                var clientNumber;

                for(var clientCounter = 0; clientCounter < clientList.length; clientCounter++) {
                    clientNumber = clientList[clientCounter].clientNumber;
                    if(groupCode == clientNumber){
                        return clientList[clientCounter].clientName;
                    }
                }
            };

            getHmAccountTypes = function(accountType, returnCode, clientCode,accountTypes) {

                if ( accountType == "HCRA" ) {
                   // memberData = //dataManager.getUser();
                    var   hcraData =  userUtil.extractHcraIndicator(memberData);
                    var hcraIndicator = hcraData[clientCode];
                    if ( hcraIndicator != "NONE") {
                        if ( hcraIndicator == "LMED" )
                            accountType = "HCRA_L";
                    }
                }

                var accountTypesObj = accountTypes;
                if(returnCode == "accountDescription") {
                    for(var accountTypesCounter = 0; accountTypesCounter < accountTypesObj.length; accountTypesCounter++) {
                        if(accountTypesObj[accountTypesCounter].acclarisCode == accountType) {
                            return accountTypesObj[accountTypesCounter].hmAccountDescription;
                        }
                    };
                }

                if(returnCode == "shortCode") {
                    for(var accountTypesCounter = 0; accountTypesCounter < accountTypesObj.length; accountTypesCounter++) {
                        if(accountTypesObj[accountTypesCounter].acclarisCode == accountType) {
                            return accountTypesObj[accountTypesCounter].hmAccountCode;
                        }
                    };
                };
            };
            getFinalHmAccountDisplaySeq=function(accountType,displaySeq,electionList){
                var CancellCount = 0;
                var isCancelled = false;
                var finalDisplaySeq = displaySeq ;
                if (electionList) {
                    for (var x in electionList) {
                        var election = electionList[x];
                        if (election.endDate != "" && election.endDate != null) {
                            var endDateParts = election.endDate.split("/");
                            var currentDate = new Date();
                            var yyyy = endDateParts[2];
                            var mm = endDateParts[0];
                            var dd = endDateParts[1];
                            var month = mm-1;
                            var endDate = new Date(yyyy,month,dd);
                            isCancelled = (endDate.getTime() < currentDate.getTime());
                        }

                        if (isCancelled ) {
                            CancellCount++;
                        }
                    }
                    // If there are elections and the number of cancelled elections is equal to
                    // the total number of elections in the list, then the account is cance;led one..
                    if (electionList.length > 0 && CancellCount == electionList.length ) {
                        isCancelled = true;
                        finalDisplaySeq = 100 + displaySeq; // cancelled accounts display seq start with 100, an arbitrory number

                    }
                }
                return finalDisplaySeq;

            };

            var acclarisSSO =function(payload){
                if(payload){
                    services.rbsmbl.acclaris().postData({payload: payload}).then(function (success) {
                        var ssoFormConfig = {
                            name: 'acclarisSSOpriorYearForm',
                            id: 'acclarisSSOpriorYearFormId',
                            formTarget: 'InvisibleSsoSvcs',
                            method: 'POST',
                            action: success.data.payload.redirectionURL
                            + '?cm_sp=SPENDING%20SSO-_-ACCLARIS%20SSO-_-ACCESS%20PRIOR%20PLAN%20YEAR',
                            target: 'acclarisWindow',
                            inputs: {
                                cookieData: success.data.payload.cookieData,
                                userName: success.data.payload.userName,
                                destinationURL: success.data.payload.destinationURL,
                                URLparms: success.data.payload.URLparms
                            }
                        };
                        invisibleForm.submit(ssoFormConfig);
                    }, function (error) {
                        coremetrics.elementTag('MEMBER:SPENDING:ACCLARIS ERROR', 'MEMBER:SPENDING:MANAGE SPENDING ACCOUNTS');
                    });
                }

            };

            newAcclaris = function (passedData) {
                var lParams={};

                lParams.groupId = passedData.groupNumber;    //plan.groupNumber;
                lParams.memberId = passedData.memberId;      //plan.memberId;
                lParams.csr = passedData.csr;                // false;
                lParams.DLParams = passedData.DLParams;      //"obj~SETTLEDDBCARDTRXN-Section";
                lParams.userRole = passedData.userRole;    //"MEMBER";
                acclarisSSO(lParams);
            };
            isCSR =function(){
                var emkt_userName = $cookies.get("emkt_userName");
                if(emkt_userName && emkt_userName.indexOf("CSR/DAS") > -1){
                    return true;
                }
                return false;
            };

            isFutureAccount=function(data) {
                // Is future account if all elections are in the future.
                var futureCount = 0;
                var isFuture = false;

                if (data && data.electionList) {
                    for (var x in data.electionList) {
                        var election = data.electionList[x];

                        var isFutureEffective = false;
                        if (election.effectiveDate != "" && election.effectiveDate != null) {
                            var effectiveDateParts = election.effectiveDate.split("/");
                            var currentDate = new Date();
                            var effectiveDate = new Date(effectiveDateParts[2], effectiveDateParts[0] - 1, effectiveDateParts[1]);
                            isFutureEffective = (effectiveDate.getTime() > currentDate.getTime());
                        }

                        if (election.enrollmentStatus === "Pending Security Check" || isFutureEffective ) {
                            futureCount++;
                        }
                    }
                    // If there are elections and the number of future elections is equal to
                    // the total number of elections in the list, then the account is future.
                    if (data.electionList.length > 0 && futureCount == data.electionList.length) {
                        isFuture = true;
                    }
                }
                return isFuture;
            };
            isCancelledAccount= function(data) {
                //console.log(data);
                return false;
            };
            jsonScrubber = function(key, value) {
                if (typeof value === "string") {
                    return value.replace(/(<[^>]*>)|([^ -~])/g, "");
                }  else {
                    return value;
                }
            };

            getHmAccountTypesNoNull = function(accountType, returnCode, clientCode,spendingAccountTypes) {
                var type = this.getHmAccountTypes(accountType, returnCode, clientCode,spendingAccountTypes);
                if (type == null) type = accountType;
                return type;
            };
            sortReceiptsByServiceDateAscending =function (a, b) {
                return new Date(a.serviceDate) - new Date(b.serviceDate);
            };

            sortReceiptsByServiceDateDescending = function (a, b) {
                return new Date(b.serviceDate) - new Date(a.serviceDate);
            };




            return {
                getHmAccountDisplaySeq: getHmAccountDisplaySeq,
                getClientName: getClientName,
                getHmAccountTypes: getHmAccountTypes,
                getFinalHmAccountDisplaySeq: getFinalHmAccountDisplaySeq,
                acclarisSSO:acclarisSSO,
                newAcclaris:newAcclaris,
                isCSR:isCSR,
                isFutureAccount:isFutureAccount,
                isCancelledAccount:isCancelledAccount,
                jsonScrubber:jsonScrubber,
                getHmAccountTypesNoNull:getHmAccountTypesNoNull,
                sortReceiptsByServiceDateAscending:sortReceiptsByServiceDateAscending,
                sortReceiptsByServiceDateDescending:sortReceiptsByServiceDateDescending
            };
        }
    ]);
};